<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>视频管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form">
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="请输入关键词"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <!-- 新增按钮  -->
          <el-button type="success"
            @click="dialogVisible = true; form = { isEnable: true, isTop: false, sort: 0 }; cateList = [];">新增</el-button>
        </el-form-item>
      </el-form>


      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>视频管理</span>
        </div>

        <el-tabs v-model="query.type" @tab-click="selList()">
          <el-tab-pane :label="item.label" :name="item.id.toString()" v-for="item in videoType"
            :key="item.id"></el-tab-pane>
        </el-tabs>
        <!-- 列表定义 -->
        <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width: 100%"
          :tree-props="{ children: 'children' }">
          <!-- 标题字段的一一对应  -->
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column label="所属类型" prop="typeName"></el-table-column>
          <!-- <el-table-column label="视频地址">
            <template slot-scope="scope" width="150px">
              <img :src="domain + scope.row.videoUrl" :style="{ height: '50px' }" alt />
            </template>
</el-table-column> -->

          <el-table-column prop="sort" label="排序" width="80"></el-table-column>
          <el-table-column label="置顶" width="70">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isTop" type="danger">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="是否可用">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.isEnable == true">是</el-tag>
              <el-tag type="warning" v-else>否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="添加时间"></el-table-column>
          <!-- 操作 -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button type="warning" size="mini" icon="el-icon-delete" @click="delClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 form表单  dialogOpened操作对话框事件-->

    <!-- dialog对话框 三元运算符 布尔表达式，如果id大于0，为true，条件成立，执行表达式1 .编辑视频。 如果id大于0，为false，执行添加视频的表达式2  -->
    <el-dialog :title="form.id > 0 ? '编辑视频' : '添加视频'" :visible.sync="dialogVisible" @opened="dialogOpened()">
      <!--   -->
      <!-- form表单  -->

      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">
        <el-form-item label="标题" prop="title" :rules="[
          { required: true, message: '请输入标题' },
          { min: 2, max: 30, message: '标题最少2字，最大30字' },
        ]">
          <el-input v-model="form.title" placeholder="请输入标题"></el-input>
        </el-form-item>

        <el-form-item label="图片" :rules="[{ required: true, message: '不能为空' }]">
          <div id="uploadBtn1" class="uploader uploader-warning"></div>
          <img id="relativeName" :src="domain + form.imgUrl"
            style="height: 40px; position: relative; left: 10px; top: 20px" v-if="form.imgUrl" />
          <div class="uploader-text">* 图片尺寸：推荐500px*335px</div>
        </el-form-item>

        <el-form-item label="视频地址" :rules="[{ required: true, message: '不能为空' }]">
          <div id="uploadBtn2" class="uploader uploader-warning"></div>
          <span id="relativeName" style="margin-left: 20px">{{
            form.videoUrl
          }}</span>
                    <span class="imgtext" title type="info"
            style="position: relative;  left: 0px;  top: 1px">*视频格式：mp4；视频最大不超过1G；</span>
        </el-form-item>

        <!-- 所属分类代码顶部  -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属分类" prop="type" :rules="{ required: true, message: '不能为空' }">
              <!-- 下拉选择  -->
              <el-select v-model="form.type" placeholder="请选择类型" filterable style="width: 100%">
                <el-option v-for="item in videoType" :label="item.label" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 分类底部 -->

        <el-form-item label="简介" prop="summary">
          <el-input v-model="form.summary" placeholder="请输入简介内容"></el-input>
        </el-form-item>

        <el-form-item label="排序字段" prop="sort">
          <el-input v-model.number="form.sort" placeholder="请输入排序字段"></el-input>
        </el-form-item>

        <el-form-item label="置顶">
          <el-switch v-model="form.isTop"></el-switch>
          <span class="uploader-text" style="margin-left:10px">当前分类内置顶，不限数量</span>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// 1  首先引入urlhelper。js 控制器代码文件
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(), // 获取域名 

      key: "",
      query: { type: "78" }, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      videoType: [],
      id: 0,
    };

  },

  // 2 方法
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    // 2.1  查询列表  JS函数getlist函数，  访问C#接口方法为主要 
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      // 打印一下，查看变量中存在的数据内容
      console.info(params);

      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.key = _this.key;

      // console.info(key);
      var link = url.getVideo("GetList_Video");// C#中的接口 方法名字。 

      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    //获取视频类型列表
    video: function () {
      var _this = this;
      var modelid = 3;
      var link = url.getSys_BasicData("GetBaseTree");
      // jquery 方法使用 1 
      $.get(link, { modelid: modelid }, (data) => {
        _this.videoType = data;
      });
    },

    //上传文件 与template模板中的dialogOpened事件呼应关系
    dialogOpened: function () {
      var _this = this;

      // console.info(_this);

      // 上传视频

      $("#uploadBtn2").uploader({
        text: "上传视频",
        type: 'single',
        fileExts: "mp4",
        uploadType: 3,
        debug: true,
        maxSize: 1024 * 1024 * 500,
        onSuccess: function (data) {
          var src = url.getDomain() + data.absoluteName;
          _this.$set(_this.form, "videoUrl", data.absoluteName);
        },
      });


      // 上传图片
      if ($("#uploadBtn1 input").length == 0) {
        $("#uploadBtn1").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png",
          type: "dialog",
          coverParams: {
            targetWidth: 500,
            targetHeight: 335,
            itemWidth: 700,
            itemheight: 500,
          },
          maxSize: 1024 * 1024 * 1,
          onSuccess: function (data) {
            var src = url.getDomain() + data.relativeName;
            _this.$set(_this.form, "imgUrl", data.relativeName);
          },
        });

      }
    },

    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getVideo("Save_Video");
      var info = this.form;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function (row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    //删除函数定义  
    delClick: function (row) {
      var _this = this;
      var link = url.getVideo("Delete_Video"); //获取请求地址
      var id = row.id; //获取对象id

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        concelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: id }, (res) => {
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  mounted() {
    // 获取视频类型
    this.video();
    //获取服务器列表
    this.getList();
  },
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}

.el-form-item--small.el-form-item {
  margin-right: 0px;
}

.el-button--primary {
  margin-left: 10px;
}
</style>
